<ng-container
  *ngIf="{
    report: report$ | async,
  } as content"
>
  @if (!content.report?.isLoading) {
    @if (!content.report?.hasError) {
      <div class="report-header m-t-20">
        <p>
          <span class="title">{{ 'reports.programStatus.title' | cxTranslate }}:</span>
          <span class="value">{{ content.report?.report?.programStatus }}</span>
        </p>

        <p>
          <span class="title">{{ 'reports.programStatus.ytdPurchase' | cxTranslate }}:</span>
          <span class="value">{{ content.report?.report?.ytdPurchase?.formattedValue }}</span>
        </p>
      </div>

      <div class="pricing-status m-t-20">
        <p class="section-title m-0">{{ 'reports.programStatus.pricingStatus' | cxTranslate }}</p>

        <table class="table-responsive table-md m-t-20" [ngClass]="{ 'is-empty': !content.report?.report?.pricingStatus?.length }">
          <thead>
            <tr>
              <th>{{ 'reports.pricingStatus.pricingStatus.table.header.multiplier' | cxTranslate }}</th>
              <th>{{ 'reports.pricingStatus.pricingStatus.table.header.productAttr' | cxTranslate }}</th>
              <th>{{ 'reports.pricingStatus.pricingStatus.table.header.discount' | cxTranslate }}</th>
            </tr>
          </thead>
          <tbody>
            @if (content.report?.report?.pricingStatus?.length) {
              <tr *ngFor="let status of content.report?.report?.pricingStatus">
                <td>
                  <span class="responsive-title"> {{ 'reports.pricingStatus.pricingStatus.table.header.multiplier' | cxTranslate }}: </span>

                  {{ status.multiplier }}
                </td>

                <td>
                  <span class="responsive-title">
                    {{ 'reports.pricingStatus.pricingStatus.table.header.productAttr' | cxTranslate }}:
                  </span>

                  {{ status.attrValue }}
                </td>

                <td>
                  <span class="responsive-title"> {{ 'reports.pricingStatus.pricingStatus.table.header.discount' | cxTranslate }}: </span>

                  {{ status.discountValue?.formattedValue }}
                </td>
              </tr>
            } @else {
              <td colspan="3">
                <p class="text-center m-t-8">
                  {{ 'reports.noContent' | cxTranslate }}
                </p>
              </td>
            }
          </tbody>
        </table>
      </div>

      <div class="program-status m-t-20">
        <p class="section-title m-0">{{ 'reports.programStatus.programList' | cxTranslate }}</p>

        <ul class="list">
          @if (content.report?.report?.programList?.length) {
            <li *ngFor="let program of content.report?.report?.programList">{{ program.programName }}</li>
          } @else {
            <li>
              {{ 'reports.noContent' | cxTranslate }}
            </li>
          }
        </ul>
      </div>

      <!-- Section removed because it's currently not applicable to Marathon as per Marathon's request. -->
      <!-- <div class="program-status m-t-20">
        <p class="section-title m-0">{{ 'reports.programStatus.promoCodes' | cxTranslate }}</p>

        <ul class="list">
          @if (content.report?.report?.promoCode?.length) {
            <li *ngFor="let item of content.report?.report?.promoCode">{{ item }}</li>
          } @else {
            <li>
              {{ 'reports.noContent' | cxTranslate }}
            </li>
          }
        </ul>
      </div> -->
    } @else {
      <alert [alert]="alertDanger"></alert>
    }
  } @else {
    <div class="m-t-20 m-b-4">
      <local-loader></local-loader>
    </div>
  }
</ng-container>